//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpProdLangs', {
//        templateUrl: 'views/components/views/discGrpProdLangs/discGrpProdLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'discGrpProdLangsService', function ($stateParams, stateService, discGrpProdLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpProdKeyno = $stateParams.discgrpprod_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await discGrpProdLangsService.listLanguages({ discgrpprod_keyno: discGrpProdKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL
            
//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                discGrpProdLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    stateService.back();
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
